// extracted by mini-css-extract-plugin
export default {"CircleNumber":"styles_CircleNumber__f7pAD","num":"styles_num__1Nueo"};